import { createModel } from "@@/package/utils/ModelUtil";
import Model from "@@/package/mapper/Model";
import type MyCourseResponse from "~~/package/apis/course/response/MyCourseResponse";
import { CourseStatusType } from "~~/package/mapper/course/model/CourseStatusType";

export class MyCourseListModel extends Model {
  constructor(
    public id: number = 0,
    public title: string = "",
    public briefDescription: string = "",
    public skillId: number = 0,
    public skillTitle: string = "",
    public skillOrder: number = 0,
    public skillCount: number = 0,
    public totalLearningTime: number = 0,
    public totalPoint: number = 0,
    public progress: number = 0,
    public status: CourseStatusType = CourseStatusType.IS_STARTED,
    public taskId: number = 0,
    public taskOrder: number = 0,
    public trackLevelAuthFlag: boolean = false
  ) {
    super();
  }

  public static create(model: Partial<MyCourseResponse>): MyCourseListModel {
    return createModel<MyCourseListModel>(MyCourseListModel, {
      ...model
    });
  }
}
